import { render, staticRenderFns } from "./gNav.vue?vue&type=template&id=7a38ded2&scoped=true&"
import script from "./gNav.vue?vue&type=script&lang=js&"
export * from "./gNav.vue?vue&type=script&lang=js&"
import style0 from "./gNav.vue?vue&type=style&index=0&id=7a38ded2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a38ded2",
  null
  
)

export default component.exports